<div class="delivery-date-editor" [formGroup]="optionsForm">
  <div class="delivery-date-editor__field">
    <label class="delivery-date-editor__field-label">Calculation Method</label>
    <pdq-dropdown
      formControlName="calculationMethod"
      [options]="calculationMethodOptions"
      [defaultOption]="currentCalculationMethod"
      [fullWidth]="true">
    </pdq-dropdown>
  </div>

  <div class="delivery-date-editor__field">
    <label class="delivery-date-editor__field-label">Display Message</label>
    <rich-textarea
      [initialContent]="initialDisplayMessage"
      placeholder=""
      [disabledFormats]="['list:ordered']"
      (contentChange)="onDisplayMessageChange($event)">
    </rich-textarea>
    <small class="delivery-date-editor__helper">
      Dynamic fields available. Use <code>&#123;arrival_date&#125;</code> for the calculated date.
    </small>
  </div>

  <div class="delivery-date-editor__field">
    <label class="delivery-date-editor__field-label">Delivery Promise Format</label>
    <pdq-radio-group formControlName="promiseFormat">
      <pdq-radio-button [value]="promiseFormat.JUST_DATE" text="Just Date"></pdq-radio-button>
      <pdq-radio-button [value]="promiseFormat.DATE_AND_DAY" text="Date And Day"></pdq-radio-button>
    </pdq-radio-group>
  </div>

  <div class="delivery-date-editor__field">
    <label class="delivery-date-editor__field-label">Fallback Message</label>
    <pdq-input formControlName="fallbackMessage" placeholder="Enter fallback text"> </pdq-input>
    <small class="delivery-date-editor__helper">Shown when a delivery date can't be calculated</small>
  </div>

  <div class="delivery-date-editor__inline-field">
    <div class="delivery-date-editor__checkbox-group">
      <pdq-checkbox formControlName="hideIfLongDelivery" label=""></pdq-checkbox>
      Don't show if arrival date is more than
    </div>
    <pdq-input-arrows
      formControlName="hideIfLongDeliveryDaysThreshold"
      [disabled]="!isHideThresholdActive"
      min="0"
      width="60"
      widthSize="auto">
    </pdq-input-arrows>
    <span [class.delivery-date-editor__days-text--disabled]="!isHideThresholdActive">days away</span>
  </div>
</div>
